import React from "react";
import getTheCareer from "../assets/images/getTheCareer.png";

const HeroSection = () => {
  return (
    <section className="bg-gradient-to-br from-[#0a0f2c] to-[#070313] text-white px-6 md:px-20 py-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        <div className="max-w-xl text-start">
          <h1 className="text-3xl md:text-5xl font-bold leading-tight">
            Get the tech career you deserve{" "}
            <span className="text-red-500">Faster</span>
          </h1>

          <p className="mt-6 text-gray-300 text-base md:text-lg">
            No matter from which background you are we will help you start your first tech job with our
            100% Placement Assurance Program. Pay after Placement
          </p>

          <ul className="mt-6 space-y-3 text-sm md:text-base">
            {[
              "100% Placement Assurance or Full Refund",
              "Pay Only After You're Hired",
              "Exclusive Internship with Certification",
              "Fast-Track Placement in Just 8 Weeks",
              "Flexible, Career-Friendly Learning",
            ].map((item, index) => (
              <li key={index} className="flex items-center gap-2">
                <span className="text-green-400">✔</span>
                {item}
              </li>
            ))}
          </ul>

          {/* <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <button className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-semibold transition">
              Call for Free Counselling
            </button>
            <button className="bg-white text-green-600 hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition">
              A Free Chat on WhatsApp
            </button>
          </div> */}
        </div>
        <div className="flex justify-center">
          <img
            src={getTheCareer}
            alt="getTheCareer"
            className="rounded-xl shadow-lg object-cover h-[350px] md:h-[450px] w-full max-w-[500px]"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
